"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnit = void 0;
exports.WeightUnit = {
    Oz: "oz",
    Kg: "kg",
    Lb: "lb",
    G: "g",
};
//# sourceMappingURL=weight-unit.js.map